// Copy of `ember-unique-id-helper-polyfill` which itself is a copy of
// ember-source's `unique-id` helper. Embroider staticHelpers builds
// assume a `unique-id` helper will come from ember-source, and won't
// resolve it correctly. To work around this we need to use a different
// name for this helper than `unique-id`.
import { helper } from '@ember/component/helper';
export default helper(getUniqueId);
function getUniqueId() {
  return ([3e7] + -1e3 + -4e3 + -2e3 + -1e11).replace(/[0-3]/g, a => (a * 4 ^ Math.random() * 16 >> (a & 2)).toString(16));
}